// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chart2_wrapper__3zii6"};